<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                <input
                    type="text"
                    class="form-control"
                    style="margin-top:10px"
                    v-model="searchTerm"
                    placeholder="Search..."
                >
            </div>
            <div class="col-sm-6">
                <b-pagination
                    class="pull-right margin"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    align="right"
                ></b-pagination>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <b-table
                    responsive
                    fixed
                    :filter="filterQuery"
                    ref="participantsTable"
                    sort-icon-left
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :sort-desc="true"
                    sort-by="Participants.completed"
                    :items="participantProvider"
                ></b-table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        occasionId: {
            type: String
        },
        searchQuery: {
            type: String
        },
    },
    data() {
        return {
            currentPage: 1,
            fields: [], // basic default fields for front end
            loading: false,
            perPage: 10,
            query: '',
            rows: 0,
            searchTerm: '',
        }
    },
    computed: {
        filterQuery() {
            return this.searchQuery + `&name=${this.searchTerm}`;
        },
    },
    watch: {
        perPage() {
            this.currentPage = 1;
        }
    },
    methods: {
        async participantProvider(ctx, callback) {
            let
                urlParams = new URLSearchParams(window.location.search),
                endPoint = `/api/v0/occasions/${this.occasionId}/participants?action=participantsIframe&${ctx.filter}&sortBy=${ctx.sortBy}&sortDesc=${ctx.sortDesc}&page=${ctx.currentPage}&limit=${ctx.perPage}`,
                promise = await axios.get(endPoint),
                items = promise.data.data.data
            ;

            const event = new CustomEvent('participant_count', {
                detail: {
                    count: items.length
                }
            });
            event.initEvent('participant_count', true, true);
            window.dispatchEvent(event);

            Object.assign(this, {
                fields: promise.data.data.headers,
                rows: promise.data.pagination.count,
                perPage: promise.data.pagination.limit,
                currentPage: promise.data.pagination.page > promise.data.pagination.pages
                    ? 1
                    : promise.data.pagination.page,
            });

            return items || [];
        },
        refreshTable() {
            this.$refs.participantsTable.refresh();
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/Assets/components/Participants/IframeTable.vue